import React, { useEffect, useRef, useState } from "react";
import clsx from "classnames";
import { useStyles } from "./ScrollWrapper.style";

interface ScrollWrapperProps {
  children: React.ReactNode;
  isTabs?: boolean;
}

const ScrollWrapper: React.FC<ScrollWrapperProps> = ({ children, isTabs }) => {
  const classes = useStyles();

  const [isHidden, setIsHidden] = useState(false);
  const [isActiveBackdropFilter, setIsActiveBackdropFilter] = useState(false);
  const lastScrollY = useRef(0);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY === 0) {
        //keep header on top
        setIsHidden(false);
        setIsActiveBackdropFilter(false);
      }
      //just when scroll up to hide header
      else if (currentScrollY > lastScrollY.current) {
        setIsHidden(true);
        if (timeoutRef.current) clearTimeout(timeoutRef.current); // Clear old timeout

        //add backdrop filter header after 300s
        const newTimeoutId = setTimeout(() => {
          setIsActiveBackdropFilter(true);
          setIsHidden(false);
        }, 300);

        timeoutRef.current = newTimeoutId;
      } else {
        setIsHidden(false);
        setIsActiveBackdropFilter(true);
      }

      lastScrollY.current = currentScrollY;
    };

    window?.addEventListener("scroll", handleScroll);

    // Call it once to set the initial state based on the current scroll position
    handleScroll(); 

    return () => {
      window?.removeEventListener("scroll", handleScroll);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  return (
    <div
      className={classes.root}
      style={{
        transform: isHidden ? "translateY(-100%)" : "translateY(0)",
        height: !isTabs ? 70 : "",
      }}
    >
      <div
        className={clsx(
          classes.backdropFilter,
          isActiveBackdropFilter ? classes.show : classes.hide,
        )}
      />
      {children}
    </div>
  );
};

export default ScrollWrapper;
